import { createSelector } from 'reselect'
import getInfoCartSelect from 'modules/cart/redux/selectors/get-info-cart'
import isEmptyObjectUtil from 'utils/object/is-empty'

const hasInfoCartSelect = createSelector(
  getInfoCartSelect,
  /**
   * @param {CartInfoResp} cartInfo
   * @returns {boolean}
   */
  cartInfo => {
    return !isEmptyObjectUtil(cartInfo)
  }
)

export default hasInfoCartSelect
